import { atom, useAtom } from "jotai"

const dialogCountAtom = atom<number>(0)

export default function useIsAnyDialogOpen() {
    const [dialogCount, setDialogCount] = useAtom(dialogCountAtom)

    const isAnyDialogOpen = dialogCount > 0

    const setIsAnyDialogOpen = (isOpen: boolean) => {
        setDialogCount((prevCount) => {
            const newCount = isOpen ? prevCount + 1 : prevCount - 1
            // Prevent negative counts
            return Math.max(0, newCount)
        })
    }

    return { isAnyDialogOpen, setIsAnyDialogOpen }
}
